<template>
  <nav
    class="sidebar"
    :class="{
      'sidebar--open': sidebarOpen,
      'sidebar--guide-active': introduce || showStepMenu == 7
    }"
  >
    <!-- Brand -->
    <div class="sidebar__brand">
      <router-link :to="{ name: 'Home', params: { type: paramsType, id: $route.params.id } }" class="sidebar__brand-link">
        <img src="@/assets/logo_h_w.png" alt="AutoTurn" class="sidebar__brand-logo" />
      </router-link>
    </div>

    <!-- User -->
    <div class="sidebar__user" @click="isShowUserCard = !isShowUserCard">
      <img
        :src="paramsType == 't' ? tiktokUserImg : userImg"
        class="sidebar__avatar"
        alt="User avatar"
      />
      <span class="sidebar__user-name">
        {{ paramsType == 't' ? tiktokUserName : userName }}
      </span>
    </div>

    <!-- Navigation -->
    <ul class="sidebar__nav">
      <!-- Home -->
      <li class="sidebar__nav-item">
        <router-link
          :to="{ name: 'Home', params: { type: paramsType, id: $route.params.id } }"
          class="sidebar__nav-link"
          :class="{ 'sidebar__nav-link--active': isNavActive('Home') }"
        >
          <i class="fas fa-home sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">{{ lang['components']['Sidebar']['account_text'] }}</span>
        </router-link>
      </li>

      <!-- <li class="sidebar__nav-item">
        <router-link :to="{ name: 'Form', params: { id: this.$route.params.id, adaccount_id: 'act_527321240980699', campaign_id: 6874 } }"
          class="sidebar__nav-link">
          <i class="fas fa-calendar sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">即時表單</span>
        </router-link>
      </li> -->

      <!-- <li class="sidebar__nav-item">
        <router-link :to="{ name: 'Event', params: { id: this.$route.params.id, adaccount_id: 'act_527321240980699', campaign_id: 6874 } }"
          class="sidebar__nav-link">
          <i class="fas fa-book sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">行銷活動修改頁</span>
        </router-link>
      </li> -->

      <!-- List -->
      <li v-if="viewAutoturnList" class="sidebar__nav-item">
        <router-link
          :to="{ name: 'List', params: { type: paramsType, id: $route.params.id, adaccount_id: $route.params.adaccount_id } }"
          class="sidebar__nav-link"
          :class="{
            'sidebar__nav-link--active': isNavActive('List'),
            'sidebar__nav-link--highlight': showStepMenu == 7
          }"
        >
          <i class="fas fa-bullhorn sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">{{ lang['components']['Sidebar']['campaign_list_text'] }}</span>
        </router-link>
      </li>

      <!-- CustomizeList -->
      <li v-if="viewCustomizeList" class="sidebar__nav-item">
        <router-link
          :to="{ name: 'CustomizeList', params: { type: paramsType, id: $route.params.id, adaccount_id: $route.params.adaccount_id } }"
          class="sidebar__nav-link"
          :class="{ 'sidebar__nav-link--active': isNavActive('CustomizeList') }"
        >
          <i class="fas fa-sliders-h sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">自定義活動列表</span>
        </router-link>
      </li>

      <!-- AudienceCenter -->
      <li v-if="(viewCustomizeList === false || viewAutoturnList === true) && hasAudienceAccess" class="sidebar__nav-item">
        <router-link
          :to="{ name: 'AudienceCenter', params: { type: paramsType, id: $route.params.id } }"
          class="sidebar__nav-link"
          :class="{ 'sidebar__nav-link--active': isNavActive('AudienceCenter') }"
        >
          <i class="fas fa-users sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">{{ lang['components']['Sidebar']['audience_center_text'] }}</span>
        </router-link>
      </li>

      <!-- Report -->
      <li v-if="viewCustomizeList === false || viewAutoturnList === true" class="sidebar__nav-item">
        <router-link
          :to="{ name: 'Report', params: { type: paramsType, id: $route.params.id } }"
          class="sidebar__nav-link"
          :class="{ 'sidebar__nav-link--active': isNavActive('Report') }"
        >
          <i class="fas fa-chart-pie sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">{{ lang['components']['Sidebar']['report_text'] }}</span>
        </router-link>
      </li>

      <!-- News -->
      <li class="sidebar__nav-item">
        <router-link
          :to="{ name: 'News', params: { type: paramsType, id: $route.params.id } }"
          class="sidebar__nav-link"
          :class="{ 'sidebar__nav-link--active': isNavActive('News') }"
        >
          <span class="sidebar__nav-icon-wrapper">
            <i class="fas fa-bell sidebar__nav-icon"></i>
            <span v-if="hasUnreadNews" class="sidebar__unread-dot"></span>
          </span>
          <span class="sidebar__nav-label">最新公告</span>
        </router-link>
      </li>

      <!-- Video (FB only) -->
      <li v-if="paramsType == 'f' && (viewCustomizeList === false || viewAutoturnList === true)" class="sidebar__nav-item">
        <router-link
          :to="{ name: 'Video', params: { type: paramsType, id: $route.params.id } }"
          class="sidebar__nav-link"
          :class="{ 'sidebar__nav-link--active': isNavActive('Video') }"
        >
          <i class="fas fa-play-circle sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">{{ lang['components']['Sidebar']['teaching_video_text'] }}</span>
        </router-link>
      </li>

      <!-- <li v-if="viewCustomizeList === false || viewAutoturnList === true" class="sidebar__nav-item">
        <span class="sidebar__nav-link" @click="isShowAbout = !isShowAbout">
          <i class="fas fa-book sidebar__nav-icon"></i>
          <span class="sidebar__nav-label">{{ lang['components']['Sidebar']['about_me_text'] }}</span>
        </span>
        <div v-if="isShowAbout" class="absolute left-60 w-36 z-50 text-center" :class="{ '-bottom-40': paramsType == 'f', '-bottom-28': paramsType == 't'}">
          <ShadowBox :padding="false">
            <div v-if="paramsType == 'f'" class="flex px-2 pt-2 pb-2">
              <div class="flex-grow p-2 cursor-pointer">
                <p class="text-gray-900" @click="download">{{lang['components']['Sidebar']['download_text']}}</p>
              </div>
            </div>
          </ShadowBox>
        </div>
      </li> -->
    </ul>
  </nav>

  <!-- User card backdrop (outside nav to avoid transform/overflow clipping) -->
  <div v-if="isShowUserCard" class="sidebar__backdrop" @click="isShowUserCard = false"></div>
  <!-- User card popup -->
  <div v-if="isShowUserCard" class="sidebar__user-card">
    <ShadowBox :padding="false">
      <div v-if="paramsType == 'f'" class="sidebar__user-card-content">
        <div class="sidebar__user-card-avatar">
          <img :src="userImg" class="sidebar__user-card-img" />
        </div>
        <div class="sidebar__user-card-info">
          <p class="sidebar__user-card-name">{{lang['components']['Sidebar']['info_a']}} {{ userName }} {{lang['components']['Sidebar']['info_b']}}</p>
          <p class="sidebar__user-card-account">{{ userAccount }}</p>
        </div>
      </div>
      <div v-if="paramsType == 't'" class="sidebar__user-card-content">
        <div class="sidebar__user-card-avatar">
          <img :src="tiktokUserImg" class="sidebar__user-card-img" />
        </div>
        <div class="sidebar__user-card-info">
          <p class="sidebar__user-card-name">{{lang['components']['Sidebar']['info_a']}} {{ tiktokUserName }} {{lang['components']['Sidebar']['info_b']}}</p>
          <p class="sidebar__user-card-account">{{ tiktokUserAccount }}</p>
        </div>
      </div>
      <div class="sidebar__user-card-actions">
        <button class="button border-blue" @click="logout()">{{lang['components']['Sidebar']['logout']}}</button>
      </div>
    </ShadowBox>
  </div>

  <Mask :isDisplay="introduce"/>
  <HomeMask v-if="introduce" v-bind:usLangMask="selectLang" @closeMask="doCloseMaskChange" @closeForTeaching="doCloseForTeaching"/>
</template>

<script>
import Mask from '@/components/Event/Mask.vue';
import HomeMask from '@/components/Mask/HomeMask.vue';
import ShadowBox from "@/components/ShadowBox.vue";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import axios from 'axios'
import Qs from 'qs'
import { newsApi } from '@/api/news.js'

export default {
  name: "Sidebar",
  components: {
    Mask,
    HomeMask,
    ShadowBox
  },
  props: {
    guideStepMenu: {
      type: Number,
      default: -1
    },
    lang: {
      type: Object
    },
    usLang: {
      type: String
    },
    guideOpenTeachingAgain: {
      type: String
    },
    getChangeLinkType: {
      type: String
    },
    useFbCustomizeStatusForView: {
      type: String
    },
    sidebarOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectLang: 'zh-TW',
      showStepMenu: -1,
      introduce: false,
      isShowUserCard: false,
      userName: null,
      userAccount: null,
      userImg: null,
      tiktokUserName: null,
      tiktokUserAccount: null,
      tiktokUserImg: null,
      isShowAbout: false,
      showVideoModal: false,
      videoData: {
        title: '',
        src: ''
      },
      paramsType: 'f',
      fb_in_use_num: '0_000',
      tiktok_in_use_num: '0_000',
      viewAutoturnList: false,
      viewCustomizeList: false,
      useFbAutoturnList: false,
      useFbCustomizeList: false,
      useTiktokAutoturnList: false,
      useTiktokCustomizeList: false,
      hasUnreadNews: false,
      paymentPlanId: null,
      hasAudienceAccess: false,
    };
  },
  mounted() {
    this.checkUnreadNews();
  },
  watch: {
    sidebarOpen(v) {
      if (!v) {
        this.isShowUserCard = false;
        this.isShowAbout = false;
      }
    },
    $route(v) {
      this.$emit('closeSidebar');

      let pageName = v.name;

      if(pageName != 'Home' && this.showStepMenu != -1){
        this.showStepMenu = -1;
      }

      //console.log(v.params.type);
      let routeType = v.params.type;

      // if(routeType != 'f' && routeType != 't'){
      //   v.params.id = routeType;
      //   v.params.type = 'f';
      // } else {
        this.paramsType = routeType;
      // }
      // console.log('v.params');
      // console.log(v.params.id);
      // console.log(v.params.type);

      axios
        .post('https://www.autoturn.net/api/member_info.php', Qs.stringify({
          s_code: v.params.id,
        }), {withCredentials: true})
        .then((adResponse) => {
          // console.log('adResponse:'+adResponse.data.selecded_data);
          if(adResponse.data.status == 'success'){
            this.userName = adResponse.data.return_data.name;
            this.userAccount = adResponse.data.return_data.account;
            this.userImg =  adResponse.data.return_data.img;

            this.tiktokUserName = adResponse.data.return_data.tiktok_name;
            this.tiktokUserAccount = adResponse.data.return_data.tiktok_account;
            this.tiktokUserImg =  adResponse.data.return_data.tiktok_img;

            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            todayForm = yearForm + monthForm + dateForm + timeForm;

            this.fb_in_use_num = adResponse.data.return_data.fb_in_use_num+'_'+todayForm;
            this.tiktok_in_use_num = adResponse.data.return_data.tiktok_in_use_num+'_'+todayForm;

            //console.log('this.fb_in_use_num');
            //console.log(this.fb_in_use_num);
            //console.log('this.tiktok_in_use_num');
            //console.log(this.tiktok_in_use_num);

            this.$emit('fbNum', this.fb_in_use_num);
            this.$emit('tiktokNum', this.tiktok_in_use_num);

            if(adResponse.data.return_data.first_login == 'Y' && pageName == 'Home'){
              this.introduce = true
            }

            if(adResponse.data.return_data.first_login == 'Y'){
              this.$emit('firstLoginStatus', adResponse);
            }

            this.paymentPlanId = adResponse.data.return_data.payment_plan_id;
            this.hasAudienceAccess = adResponse.data.return_data.has_audience_access || false;
            this.useFbAutoturnList = adResponse.data.return_data.use_fb_autoturn_list;
            this.useFbCustomizeList = adResponse.data.return_data.use_fb_customize_list;
            this.useTiktokAutoturnList = adResponse.data.return_data.use_tiktok_autoturn_list;
            this.useTiktokCustomizeList = adResponse.data.return_data.use_tiktok_customize_list;

            if(this.paramsType == 'f'){
              this.viewAutoturnList = this.useFbAutoturnList;
              this.viewCustomizeList = this.useFbCustomizeList;

              this.$emit('sidebarFbCustomize', adResponse.data.return_data.use_experience_customize_fin);
            }

            if(this.paramsType == 't'){
              this.viewAutoturnList = this.useTiktokAutoturnList;
              this.viewCustomizeList = this.useTiktokCustomizeList;
            }

            // 檢查未讀公告
            this.checkUnreadNews();

            // 觸發檢查最新公告彈窗
            this.$emit('loginSuccess');
          } else {
            Swal.fire({
              icon: 'error',
              title: this.lang['components']['Sidebar']['error_title'] || '錯誤',
              text: adResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['Sidebar']['confirm_button'] || '確定'
            }).then((result) => {
              if (result.isConfirmed || result.isDenied) {
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    "guideStepMenu":function(v){
      // console.log('in menu');
      // console.log(v);
      // console.log('$route', this.$route);
      if(v != '' && v != null && typeof v != 'undefined' && this.$route.name == 'Home'){
        this.showStepMenu = v
      } else {
        this.showStepMenu = -1
      }

      // console.log('guideStepMenu this.showStepMenu');
      // console.log(this.showStepMenu);
    },
    "usLang":function(v){
      this.selectLang = v
    },
    "guideOpenTeachingAgain":function(v){
      let tmpStatus = v.split('_');

      if(tmpStatus[0] == 'Y'){
        this.introduce = true
      } else {
        this.introduce = false
      }
    },
    "getChangeLinkType":function(v){
      //console.log('sidebar getChangeLinkType');
      //console.log(this.paramsType);

      let tmpType = v.split('_');
      if(tmpType[0] == 't' || tmpType[0] == 'f'){
        this.paramsType = tmpType[0]
      }

      if(this.paramsType == 'f'){
        this.viewAutoturnList = this.useFbAutoturnList;
        this.viewCustomizeList = this.useFbCustomizeList;

        this.$emit('sidebarFbCustomize', this.viewCustomizeList);
      }

      if(this.paramsType == 't'){
        this.viewAutoturnList = this.useTiktokAutoturnList;
        this.viewCustomizeList = this.useTiktokCustomizeList;
      }
      //console.log(this.paramsType);
    },
    'isShowUserCard':function(v){
      //console.log('isShowUserCard');
      //console.log(v);
    },
    useFbCustomizeStatusForView:function(v){
      //console.log('useFbCustomizeStatusForView', v);
      let tmpStatus = v.split('_');

      if(tmpStatus[0] == 'true'){
        this.viewAutoturnList = true;
        this.viewCustomizeList = true;

        this.$emit('sidebarFbCustomize', this.viewCustomizeList);
      }
    },
  },
  methods: {
    isNavActive(routeName) {
      const routeGroups = {
        'Home': ['Home'],
        'List': ['List', 'Event', 'EventBrowse', 'EventAdd', 'EventTiktok', 'EventBrowseTiktok', 'EventAddTiktok', 'StrategyEvent'],
        'CustomizeList': ['CustomizeList', 'CustomizeEvent', 'CustomizeEventBrowse', 'CustomizeEventAdd'],
        'AudienceCenter': ['AudienceCenter'],
        'Report': ['Report'],
        'News': ['News'],
        'Video': ['Video'],
      };
      return (routeGroups[routeName] || [routeName]).includes(this.$route.name);
    },
    logout(){
      // console.log("https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1");
      window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
    },
    download(){
      window.open("https://www.autoturn.net/index.php/use_instructions/download?fn=AutoTurn_dentsu 2.0 操作手冊.pdf");
    },
    toVideo(title, src){
      this.videoData.title = title
      this.videoData.src = src

      if(src != '' && src != null && typeof src != 'undefined'){
        this.showVideoModal = true;
      }
    },
    doCloseMaskChange(v){
      // axios
      //   .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
      //     s_code: this.$route.params.id,
      //   }))
      //   .then((adResponse) => {
      //     this.introduce = v
      //   });

      this.introduce = false;

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0');
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

      this.$emit('menuCheck', get_value);
    },
    doCloseForTeaching(){
      this.introduce = false

      this.$emit('closeForTeaching', false);
    },
    checkUnreadNews(){
      newsApi.hasUnreadNews()
        .then((response) => {
          if (response.data && response.data.success) {
            this.hasUnreadNews = response.data.has_unread;
          }
        })
        .catch((error) => {
          // Silent fail
        });
    }
  }
};
</script>

<style scoped>
/* ===========================
   Sidebar Container
   =========================== */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--sidebar-width);
  height: 100vh;
  background: linear-gradient(180deg, var(--navy) 0%, var(--navy-dark) 100%);
  display: flex;
  flex-direction: column;
  z-index: 30;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Grain texture overlay */
.sidebar::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.02'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
  z-index: 0;
}

.sidebar > * {
  position: relative;
  z-index: 1;
}

/* Desktop: always visible */
@media (min-width: 1024px) {
  .sidebar {
    position: sticky;
    top: 0;
    transform: translateX(0);
    flex-shrink: 0;
  }
}

/* Mobile: slide in */
.sidebar--open {
  transform: translateX(0);
}

/* Tutorial guide active state */
@media (min-width: 1024px) {
  .sidebar--guide-active {
    z-index: 100 !important;
    position: relative !important;
  }
}

/* ===========================
   Brand Area
   =========================== */
.sidebar__brand {
  padding: 28px 20px 8px;
}

.sidebar__brand-link {
  text-decoration: none;
  color: inherit;
}

.sidebar__brand-title {
  font-family: var(--font-heading);
  font-size: 26px;
  font-weight: 400;
  letter-spacing: 1px;
  color: #ffffff;
  margin: 0;
  line-height: 1.2;
}

.sidebar__brand-subtitle {
  font-family: var(--font-body);
  font-size: 11px;
  color: #60a5fa;
  letter-spacing: 3px;
  text-transform: uppercase;
  display: block;
  margin-top: 4px;
  font-weight: 300;
}

.sidebar__brand-logo {
  width: 160px;
  height: auto;
  display: block;
}

/* ===========================
   User Area
   =========================== */
.sidebar__user {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  gap: 12px;
  margin-top: 8px;
}

.sidebar__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

.sidebar__user-name {
  color: var(--text-muted);
  font-family: var(--font-body);
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

/* User card popup */
.sidebar__backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
}

.sidebar__user-card {
  position: fixed;
  top: 80px;
  left: var(--sidebar-width);
  z-index: 50;
}

.sidebar__user-card-content {
  display: flex;
  padding: 16px;
  width: 320px;
}

.sidebar__user-card-avatar {
  flex-shrink: 0;
}

.sidebar__user-card-img {
  width: 48px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
}

.sidebar__user-card-info {
  flex: 1;
  padding: 0 8px;
}

.sidebar__user-card-name {
  color: #111827;
  margin: 0;
}

.sidebar__user-card-account {
  color: #9ca3af;
  margin: 4px 0 0;
}

.sidebar__user-card-actions {
  padding: 16px;
  text-align: right;
}

/* ===========================
   Navigation
   =========================== */
.sidebar__nav {
  list-style: none;
  padding: 16px 0;
  margin: 0;
  flex: 1;
}

.sidebar__nav-item {
  margin-bottom: 4px;
}

.sidebar__nav-link {
  display: flex;
  align-items: center;
  padding: 13px 20px;
  margin-right: 16px;
  border-radius: var(--nav-pill-radius);
  color: var(--text-muted);
  text-decoration: none;
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 400;
  transition: all 0.25s ease;
  cursor: pointer;
}

.sidebar__nav-link:hover {
  color: var(--text-hover);
  background: var(--nav-hover-bg);
}

.sidebar__nav-link--active {
  color: var(--text-active);
  background: var(--nav-active-bg);
  font-weight: 600;
  box-shadow: var(--nav-active-shadow);
}

/* Tutorial highlight ring */
.sidebar__nav-link--highlight {
  box-shadow: 0 0 0 4px #ef4444;
}

.sidebar__nav-icon {
  width: 22px;
  margin-right: 12px;
  font-size: 15px;
  text-align: center;
  flex-shrink: 0;
}

.sidebar__nav-icon-wrapper {
  position: relative;
  display: inline-flex;
  width: 22px;
  margin-right: 12px;
  flex-shrink: 0;
}

.sidebar__nav-icon-wrapper .sidebar__nav-icon {
  margin-right: 0;
}

.sidebar__nav-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Unread notification dot */
.sidebar__unread-dot {
  position: absolute;
  top: -2px;
  right: -4px;
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
}
</style>
